export interface TBannerItem {
	img: string;
	link: string;
	imgTwo?: string;
	text?: string;
	width?: string;
	height?: string;
	color?: string;
	bgColor?: string;
}

export enum ModuleInteraction {
	None = "None",
	RollOver = "RollOver",
	SingleSliding = "SingleSliding",
	Zoom = "Zoom",
	ZoomSliding = "ZoomSliding",
}

export enum TActState {
	UnkonwnActState = "UnkonwnActState",
	ComingSoon = "ComingSoon",
	OnGoing = "OnGoing",
	Ended = "Ended",
}

export enum CouponType {
	CopyCoupon = "CopyCoupon",
	ReceiveCoupon = "ReceiveCoupon",
}
